import React from 'react';
import { rescueHtml, addSpace } from '../Components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page2DonneesGenerales_Operations = (props) => {
    const blue = '#069BD3';
    const purple = '#6571FE';
    const green = '#59B44A';
    const orange = '#FFA500';
    const red = '#FF0000';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const fontsize = (props.height*12/890);
    const circle = (props.height*70/950);
    const rowHeight = (props.height*30/890);

    const rowHeaderStyle = {
        height: rowHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: greyChapter,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        borderBottomLeftRadius: 3,
        margin: '0 auto'
    };

    const rowDataStyle = {
        height: rowHeight,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        borderBottomLeftRadius: 3,
        margin: '0 auto'
    };

    const rowCellTextStyle = {
        marginTop: (0-props.marge),
        fontSize: fontsize+2,
        lineHeight: 1.3
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        return dateStr;
    };

    return (
        <div style={{width: '100%', height: '100%', padding: 0, background: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', position: 'relative', overflow: 'hidden'}}>
                    
                    {/* Header avec pastilles d'état */}
                    <div style={{padding: '20px 30px', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1}}>
                        {props.logo && (
                            <img style={{objectFit: 'contain', height: 180, maxWidth: '30%', borderRadius: 8}} src={props.logo} alt="Logo" />
                        )}
                    </div>
        
                    {/* Contenu principal avec pastilles et info opération */}
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', zIndex: 1}}>
                        
                        {/* Pastilles d'état */}
                        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px'}}>
                            <div style={{margin: 3, border: `2px solid ${green}`, borderRadius: 100, width: circle, height: circle, backgroundColor: props.operation.color === green ? green : 'white'}}></div>
                            <div style={{margin: 3, border: `2px solid ${orange}`, borderRadius: 100, width: circle, height: circle, backgroundColor: props.operation.color === orange ? orange : 'white'}}></div>
                            <div style={{margin: 3, border: `2px solid ${red}`, borderRadius: 100, width: circle, height: circle, backgroundColor: props.operation.color === red ? red : 'white'}}></div>
                        </div>

                        {/* Montant */}
                        <p style={{fontSize: fontsize+6, color: '#2C3E50', margin: 0}}>
                            Opération n° {rescueHtml(props.operation.numero_inventaire || '-')}
                        </p>

                        {/* Nom de l'opération */}
                        <p style={{fontSize: fontsize+15, color: blue, marginTop: 10}}>
                            {rescueHtml(props.operation.nom || '-')}
                        </p>

                    </div>
        
                    {/* Deuxieme contenu principal - Informations détaillées */}
                    <div style={{flex: 2, padding: '10px 15px', fontSize: fontsize, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        <div style={{display: 'flex', marginBottom: fontsize, gap: 15}}>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Montant de l'opération (en € TTC)</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{props.operation.montant ? addSpace(parseFloat(props.operation.montant)) + '€' : '0€'}</p>
                                </div>
                            </div>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Collectivité</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{rescueHtml(props.operation.nom_client || '-')}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{display: 'flex', marginBottom: fontsize, gap: 8}}>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Modalité de portage</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{rescueHtml(props.operation.nom_modalite || '-')}</p>
                                </div>
                            </div>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Axe d'intervention</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{rescueHtml(props.operation.nom_axe || '-')}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{display: 'flex', marginBottom: fontsize, gap: 8}}>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Territoire</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{rescueHtml(props.operation.nom_territoire || '-')}</p>
                                </div>
                            </div>
                            <div className='shadow-md' style={{flex: 0.49}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Durée de portage (années)</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{props.operation.duree_portage ? String(props.operation.duree_portage).trim() : '0'}</p>
                                </div>
                            </div>
                            <div className='shadow-md' style={{flex: 0.49}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Durée de différé (années)</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{props.operation.duree_differe ? String(props.operation.duree_differe).trim() : '0'}</p>
                                </div>
                            </div>
                        </div>
                        <div style={{display: 'flex', marginBottom: fontsize, gap: 8}}>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Date d'acquisition</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{formatDate(props.operation.date_premiere_acquisition) || '-'}</p>
                                </div>
                            </div>
                            <div className='shadow-md' style={{flex: 1}}>
                                <div style={rowHeaderStyle}>
                                    <p style={rowCellTextStyle}>Date de facturation</p>
                                </div>
                                <div style={rowDataStyle}>
                                    <p style={rowCellTextStyle}>{formatDate(props.operation.date_premiere_facturation) || '-'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    {/* Footer - 20% */}
                    <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1, flexShrink: 0}}>
                        <div>
                            <p style={{fontSize: fontsize, color: '#666'}}>
                                {props.date}
                            </p>
                        </div>
                        <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                        <div>
                            <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                        </div>
                    </div>
                </div>
    );
};

export default Page2DonneesGenerales_Operations;
